import { MIMETYPE_GEOPACKAGE } from '@disy/lib/media-type';

import { AbstractDataViewExportAction } from 'cadenza/actions/table/abstract-data-view-export-action';
import type { ExportActionContext } from 'cadenza/workbook/actions/export-actions';
import type { DataViewId } from 'cadenza/workbook/model/data-view-id.gen';
import i18n from 'cadenza/workbook/view/view-header/actions/export-geopackage-view-toolbar-action.properties';

export class ExportGeopackageViewToolbarAction extends AbstractDataViewExportAction {
  readonly #dataViewId;
  readonly #actionContext;
  readonly #enabled;

  constructor(dataViewId: DataViewId, actionContext: ExportActionContext, enabled: boolean) {
    super(dataViewId, actionContext, MIMETYPE_GEOPACKAGE, {
      label: i18n('action.label'),
      dialogTitle: i18n('dialog.title'),
      tooltip: enabled ? undefined : i18n('disabled.tooltip'),
    });
    this.#dataViewId = dataViewId;
    this.#actionContext = actionContext;
    this.#enabled = enabled;
  }

  override async execute() {
    const { GeoPackageViewToolbarExportDialog } =
      await import('cadenza/geo-package-view-toolbar-export-dialog/geo-package-view-toolbar-export-dialog');
    const exportDialog = new GeoPackageViewToolbarExportDialog(this.#dataViewId, this.#actionContext);
    exportDialog.connectAndShow();
  }

  override get enabledSync() {
    return this.#enabled;
  }
}
